function noHttpAndIpInQueryValidator(value: string): boolean {
  return /^[^?]*(\?(?!.*(http:\/\/|(127|10|169\.254|172\.(1[6-9]|2[0-9]|3[0-1])|192\.168|22[4-9]|23[0-9])\.\d{1,3}\.\d{1,3})).*)?$/.test(value);
}

export default noHttpAndIpInQueryValidator;
